import { css, SerializedStyles } from '@emotion/react';

import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';



export const styleNavIcon = (theme: EmotionTheme): SerializedStyles => css`

    background-color: ${theme.star.traderChat.notification.bgColorSecondary};

    border-radius: 50%;

    fill: ${theme.star.traderChat.notification.bgColorTertiary};

    height: 40px;

    left: 16px;

    padding: 8px;

    position: absolute;

    top: 12px;

    width: 40px;

`;

